import React from 'react'
import { NavBar } from '../nav-bar'
import styles from './index.module.css'
import { Link } from '../Link'
export default function Header() {
  const headerRef = React.useRef(null)

  /*
  React.useEffect(() => {
    //if (!window) return

    const selectHeader = headerRef.current
    if (selectHeader) {
      const headerScrolled = () => {
        if (globalThis.window.scrollY > 100) {
          selectHeader.classList.add(styles.headerBarHeaderScrolled)
        } else {
          selectHeader.classList.remove(styles.headerBarHeaderScrolled)
        }
      }
      globalThis.window.addEventListener('load', headerScrolled)
      globalThis.document.addEventListener('scroll', headerScrolled)
    }
  }, [])

   */

  return (
    <header ref={headerRef} id="header" className={`${styles.headerBar} fixed-top d-flex align-items-center`}>
      <div className="container d-flex align-items-center">
        <h1 className={`${styles.logo} me-auto`}>
          <Link reloadDocument to="/">
            Total Milk
          </Link>
        </h1>
        <NavBar />
      </div>
    </header>
  )
}
